<template>
  <div>
    <page-header title="Shipment Timeline" breadcrumb="Dashboard > Bookings & Shipments  > Trackings"
      back="/operations/booking" />
    <div class="custom-card" :booking="booking">
      <div class="flex justify-between items-center">
        <p>
          Shipping ID: #{{ shipment.shippingReference }}
          <span class="text-lightGrey ml-4">{{ createdDate }}</span>
        </p>
        <base-button text="Update Shipping Status" @click="shppingStatus(shipment)" />
      </div>
      <div class="p-4 mt-4 flex gap-4 text-white" style="background: #09b78a">
        <span class="icon-bg">
          <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.94192 1.40008L1.80192 8.49058C1.52142 8.76816 1.29874 9.09861 1.14676 9.4628C0.994791 9.82699 0.916541 10.2177 0.916541 10.6123C0.916541 11.007 0.994791 11.3977 1.14676 11.7619C1.29874 12.1261 1.52142 12.4565 1.80192 12.7341L6.76692 17.6661C7.94742 18.8361 9.85842 18.8361 11.0374 17.6661L18.0724 10.6791C18.6322 10.1227 18.9501 9.36824 18.9574 8.57908L18.9934 3.52108C18.9948 3.12296 18.9172 2.72851 18.7652 2.36056C18.6131 1.99262 18.3895 1.6585 18.1075 1.37754C17.8254 1.09658 17.4904 0.874357 17.1218 0.723741C16.7533 0.573125 16.3585 0.497106 15.9604 0.500084L11.0644 0.521084C10.2692 0.523719 9.50686 0.838886 8.94192 1.39858V1.40008ZM15.0289 5.98708C14.8115 6.20271 14.5177 6.3237 14.2114 6.3237C13.9052 6.3237 13.6114 6.20271 13.3939 5.98708C13.2868 5.88083 13.2018 5.75442 13.1438 5.61514C13.0857 5.47586 13.0559 5.32647 13.0559 5.17558C13.0559 5.0247 13.0857 4.87531 13.1438 4.73603C13.2018 4.59675 13.2868 4.47034 13.3939 4.36408C13.6114 4.14846 13.9052 4.02747 14.2114 4.02747C14.5177 4.02747 14.8115 4.14846 15.0289 4.36408C15.4789 4.81408 15.4789 5.54008 15.0289 5.98708ZM0.996422 13.6251C0.794917 14.1644 0.752827 14.7502 0.875175 15.3127C0.997522 15.8753 1.27914 16.3907 1.68642 16.7976L4.63242 19.7436C5.18958 20.3008 5.85103 20.7428 6.579 21.0443C7.30697 21.3458 8.08721 21.5011 8.87517 21.5011C9.66313 21.5011 10.4434 21.3458 11.1713 21.0443C11.8993 20.7428 12.5608 20.3008 13.1179 19.7436L18.3409 14.5206C18.763 14.099 19.0004 13.5271 19.0009 12.9306V11.7606L13.1179 17.6436C13.0144 17.7471 12.9079 17.8461 12.7999 17.9391L12.0574 18.6831C11.6395 19.101 11.1434 19.4326 10.5974 19.6588C10.0514 19.885 9.46618 20.0014 8.87517 20.0014C8.28416 20.0014 7.69894 19.885 7.15292 19.6588C6.60691 19.4326 6.1108 19.101 5.69292 18.6831L4.94442 17.9346C4.83707 17.8412 4.73301 17.7442 4.63242 17.6436L1.68642 14.6976C1.38196 14.3939 1.1466 14.0281 0.996422 13.6251Z"
              fill="#09B78A" />
          </svg>
        </span>
        <div class="flex flex-col">
          <p class="font-semibold">
            {{
              (shipment.shippingMethod
                ? shipment.shippingMethod
                : "N/A"
              ).toUpperCase()
            }}
          </p>
          <span v-if="shipment.deliveryStatus == 'completed'">This order has been shipped to the customer </span>
          <span v-else>The order of this shipment is on its way to the customer </span>
        </div>
      </div>
      <div class="timeline-wrapper">

        <div class="simple"
          :style="{ width: `${(currentTimeLine.timelines.length ? currentTimeLine.timelines.length : 1 / timeLine) * 25}%` }">
        </div>
        <div class="timeline ">
          <div class="points">
            <el-tooltip class="item" effect="dark" content="Top Left prompts info" placement="top">
              <div></div>
            </el-tooltip>
            <p> {{ 'Pending' }} </p>
            <span> {{ createdDate }} </span>
          </div>

          <div class="points" v-for="timeline in currentTimeLine.timelines" :key="timeline.id">
            <el-tooltip class="item" effect="dark" content="Top Left prompts info" placement="top">
              <div></div>
            </el-tooltip>
            <p> {{ timeline.activityType }} </p>
            <span> {{ moment(timeline.updatedAt).format("MMMM Do YYYY, h:mm:ss a") }} </span>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2 p-4" style="background: #f9fafc">
        <p class="font-normal">Shipping Information</p>
        <div class="row p-3">
          <div class="col-md-3 flex flex-col gap-4">
            <p class="font-semibold">SENDER INFORMATION</p>
            <p class="flex flex-col">
              {{ shipment && shipment.shipperlocation && shipment.shipperlocation.contactName }}
              <span class="text-red">
                {{ shipment && shipment.shipperlocation && shipment.shipperlocation.mobile }}</span>
            </p>
            <p>
              {{ shipment && shipment.shipperlocation && shipment.shipperlocation.address.name }}
            </p>
          </div>
          <div class="col-md-3 flex flex-col gap-4">
            <p class="font-semibold">RECEPIENT INFORMATION</p>
            <p class="flex flex-col">
              {{ receieverContactName }}
              <span class="text-red">{{
                receieverMobile
                }}</span>
            </p>
            <p>
              {{ receieverAddress }}
            </p>
          </div>
          <div class="col-md-3 flex flex-col gap-4">
            <p class="flex flex-col gap-1">
              <span class="font-semibold">ORDER CHANNEL</span>
              <span v-if="shipment.shippingservice != null">
                {{
                  shipment.shippingservice.orgName
                    ? shipment.shippingservice.orgName
                    : "N/A"
                }}</span>
              <span v-else>
                N/A
              </span>
            </p>
            <p class="flex flex-col gap-1">
              <span class="font-semibold">ORDER #</span><span>#{{ shipment.shippingReference }} </span>
            </p>
            <p class="flex flex-col gap-1">
              <span class="font-semibold">SHIPPING COST</span><span>N{{
                shipment.transaction
                  ? shipment.transaction.totalValue
                  : "N/A"
              }}</span>
            </p>
          </div>
          <div class="col-md-3 flex flex-col gap-4">
            <p class="flex flex-col gap-1">
              <span class="font-semibold">SHIPPING COST</span><span>N{{
                shipment.transaction
                  ? shipment.transaction.totalValue
                  : "N/A"
              }}</span>
            </p>
            <p class="flex flex-col gap-1">
              <span class="font-semibold">PAYMENT STATUS</span>
              <span class="flex gap-2">
                {{ (shipment.paymentStatus ? shipment.paymentStatus : "N/A").toUpperCase() }}
                <span v-if="(shipment.paymentStatus).toLowerCase() == 'not paid'">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width:25px">
                    <path
                      d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                  </svg>
                </span>
                <span v-else>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.3337 9.23355V10.0002C18.3326 11.7972 17.7507 13.5458 16.6748 14.9851C15.5988 16.4244 14.0864 17.4773 12.3631 17.9868C10.6399 18.4963 8.79804 18.4351 7.11238 17.8124C5.42673 17.1896 3.98754 16.0386 3.00946 14.5311C2.03138 13.0236 1.56682 11.2403 1.68506 9.44714C1.80329 7.65402 2.498 5.94715 3.66556 4.58111C4.83312 3.21506 6.41098 2.26303 8.16382 1.867C9.91665 1.47097 11.7505 1.65216 13.392 2.38355"
                      stroke="#09B78A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M18.3333 3.3335L10 11.6752L7.5 9.17516" stroke="#09B78A" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="see-modal shadow rounded" v-show="viewModal == true">
        <form>
          <div class="particulars-img-wrapper">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 col-lg-12 col-12">
                  <label for="" class="label">Current Status</label>
                  <input type="text" class="input" v-model="shipment.deliveryStatus" disabled />
                </div>
                <div class="col-md-12 col-lg-12 col-12">
                  <label for="" class="label">Updated By</label>
                  <input type="text" class="input" v-model="updatedBy" disabled />
                </div>
                <div class="col-md-12 col-lg-12 col-12">
                  <label for="" class="label">Date Last Updated</label>
                  <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
                    v-model="shipment.updatedAt" />
                </div>
                <div class="col-md-12 col-lg-12 col-12">
                  <label for="" class="label">New status</label>
                  <select class="form-control" v-model="status">
                    <option :value="`select status`">select status</option>
                    <option v-for="(option, i) in loadedStatus" :key="i" :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="button-wrapper">
            <button @click.prevent="closemodal" class="bg-transparent  btn">
              Cancel
            </button>
            <button @click.prevent="updateStatus" class="btn bt">Update</button>
          </div>
        </form>
      </div>
      <div class="">
        <p class="font-semibold">Order Items</p>
        <table class="custom-table responsive-table border-collapse">
          <thead>
            <tr class="shadow-md rounded-lg">
              <th>Item</th>
              <th>Quantity</th>
              <th>Dimension (Cm)</th>
              <th>Gross Weight(kg)</th>
              <th>Total Cost(N)</th>
            </tr>
          </thead>
          <tbody>
            <tr class="shadow-md rounded-lg" v-for="pack in shipment.packagees" :key="pack">
              <td>{{ pack.description ? pack.description : "N/A" }}</td>
              <td>{{ pack.quantity ? pack.quantity : "N/A" }}</td>
              <td>{{ pack.length ? pack.length : "N/A" }}</td>
              <td>{{ pack.estimatedWeight ? pack.estimatedWeight : "N/A" }}</td>
              <td>{{ pack.itemValue ? pack.itemValue : "N/A" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: { PageHeader },
  props: {
    booking: Object,
    currentStatus: String,
    lastUpdated: String,
  },
  data() {
    return {
      shipId: '',
      checkShipment: [],
      currentTimeLine: [],
      timeLine: 7,
      shipment: [],
      updatedBy:
        this.$store.getters.user.firstname +
        " " +
        this.$store.getters.user.lastname,
      loadedStatus: [],
      viewModal: false,
      createdDate: "",
      status: "",
    };
  },
  mounted() {
    this.shipId = this.$route.params.id
    this.getShipment()
    this.getShippingsStatus();
    this.createdDate = moment(this.shipment.createdAt).format(
      "MMMM Do YYYY, h:mm:ss a"
    );
    this.getTimeLine()
  },
  computed: {
    receieverContactName() {
      return (this.currentTimeLine?.shipmentReceiever || []).map((item) => item?.location?.contactName).join(",")
    },
    receieverMobile() {
      return (this.currentTimeLine?.shipmentReceiever || []).map((item) => item?.location?.mobile).join(",")
    },
    receieverAddress() {
      return (this.currentTimeLine?.shipmentReceiever || []).map((item) => item?.location?.address?.name).join(",")
    },
  },
  methods: {
    async getShipment() {
      try {
        let response = await this.$_getShipmentById(this.shipId);
        this.shipment = response.data.data.shipping
      } catch (error) {
        this.handleError(error);
      }
    },
    moment(date) {
      return moment(date)
    },
    closemodal() {
      this.viewModal = false;
    },
    shppingStatus() {
      this.viewModal = true;
    },
    async getShippingsStatus() {
      try {
        let response = await this.$_getShippingsStatus();
        this.loadedStatus = response.data.data;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async getTimeLine() {
      try {
        let response = await this.$_getShippingTimeline(this.shipId)
        this.currentTimeLine = response.data.data.shippingActivity;
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateStatus() {
      const request = {
        deliveryStatus: this.status,
        message: "Status Updated to " + this.status
      };

      try {
        await this.$_updateShippingStatusByDriver(this.shipment.id, request);
        this.loading = true;
        this.viewModal = false;
        this.generateToast("Shiping Updated", "success");
        this.loading = false;
        this.getTimeLine()
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.simple {
  background-color: #f8cd7e;
  padding: 3px;
  border-radius: 10px;
  position: relative;
  top: 23px;
  z-index: 1;
  transition: all 0.3s linear;
  max-width: 150%;
}

.timeline-wrapper {
  overflow-x: auto;
  width: 100%
}

.timeline {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  justify-content: space-between;

  .points {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    border-radius: 5px;
    background: #f9fafc;
    text-align: center;

    div {
      padding: 5px;
      margin: 0 auto;
      background-color: white;
      border-radius: 50%;
      border: 5px solid orange;
      z-index: 2;
    }

    p {
      font-size: 12px;
      font-weight: 500;
      color: #000;
    }

    span {
      color: #10233e;
      font-size: 12px;
      font-weight: 100;
      color: #000;
    }
  }
}

.icon-bg {
  width: 50px;
  background: white;
  padding: 1rem;
  display: block;
  border-radius: 50%;
}

.see-modal {
  position: absolute;
  background-color: white;
  border: 1px solid rgb(214, 205, 205);
  top: 200px;
  left: 40%;
  padding: 10px 20px;
  width: 400px;
  z-index: 10;
}

.bt {
  @apply bg-primary-yellow;
  color: #313235 !important;
}

.btn {
  color: #000
}
</style>